// src/theme.js
import { createTheme } from '@mui/material/styles';
import { PROGRAM } from './helpers/accounts';

const shared = {
    typography: {
        fontFamily: 'Arial, Helvetica, sans-serif',
    },
};

export const libraryTheme = createTheme({
    ...shared,
    palette: {
        primary: {
            main: '#80a748',
        },
        brandGradient: 'linear-gradient(315deg, #80a748 0%, #a2c857 50%, #5e7d2a 100%)',
    },
});

// The reading programme is deliberately a different colour from the
// subscription library: a parent may hold both accounts, and the colour is the
// quickest way to see which one is open.
export const programTheme = createTheme({
    ...shared,
    palette: {
        primary: {
            main: '#b06f00',
        },
        brandGradient: 'linear-gradient(315deg, #b06f00 0%, #d99a2b 50%, #8a5400 100%)',
    },
});

export const themeFor = scope => (scope === PROGRAM ? programTheme : libraryTheme);

export default libraryTheme;
